<script lang="ts">
import { loadProjectPage } from '@/dashboard/utils/project/loadProjectPage';
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

type ParamsType = {
  short_link: string;
  user_id: string | undefined;
};

export default {
  beforeRouteEnter: async function (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
    next();
    const shortLink = (to.params as ParamsType).short_link;
    await loadProjectPage(shortLink);
  },
  beforeRouteUpdate: async function (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
    next();
    const shortLink = (to.params as ParamsType).short_link;
    await loadProjectPage(shortLink);
  },
};
</script>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import PublicMainDrafts from '@/dashboard/vue/components/public/PublicMainDraft/PublicMainDrafts.vue';
import LoaderIcon from '@/dashboard/vue/components/icons/LoaderIcon.vue';
import { usePublicStore } from '@/dashboard/store/publicStore';

const publicStore = usePublicStore();
const { pageLoader } = storeToRefs(publicStore);
</script>

<template>
  <div class="w-full flex-1 px-s pt-[56px] laptop:pt-[63px]">
    <div class="flex min-h-full w-full flex-1">
      <div v-if="pageLoader" class="flex flex-1 items-center justify-center">
        <LoaderIcon class="animate-spin stroke-black dark:stroke-white" />
      </div>

      <PublicMainDrafts v-else />
    </div>
  </div>
</template>
